module.exports = __webpack_public_path__ + "static/media/balloon.1cf5341d.png";